import { render } from "./BenefitCreateComponent.vue?vue&type=template&id=2ea42bf3"
import script from "./BenefitCreateComponent.vue?vue&type=script&lang=js"
export * from "./BenefitCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Benefit/BenefitCreateComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ea42bf3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ea42bf3', __exports__)) {
    api.reload('2ea42bf3', __exports__)
  }
  
  module.hot.accept("./BenefitCreateComponent.vue?vue&type=template&id=2ea42bf3", () => {
    api.rerender('2ea42bf3', render)
  })

}


export default __exports__